/**
 * Enum for Album Modes
 */
const AlbumModeEnum = {
    // only delivery, no sales or purchases
    DELIVERY_ONLY: 0, 
    // venta individual de multimedios
    // individual sale of media
    INDIVIDUAL_SALE: 1,
    // free access, download at no cost
    FREE_GALLERY: 3, 
};

export default AlbumModeEnum;
